export const selectOptionsExceptionStatus = [
  "Open",
  "In Review",
  "In Review - Pending Credit Committee",
  "Approved",
  "Rejected",
];

/**
 * Statuses that mean the exception is settled. Moving into one of these stamps
 * `resolutionDateTime`; moving back out of them clears it (see
 * LoanExceptionForm). "No Longer Applies" is listed ahead of being added to the
 * dropdown so the stamp works the moment that option ships.
 */
export const resolvedExceptionStatuses = [
  "Approved",
  "Rejected",
  "No Longer Applies",
];

export const isResolvedExceptionStatus = (status) =>
  resolvedExceptionStatuses.includes(status);
